import React, { FC } from "react";
import { IconToggle } from "@evergis/ui";
import { useActionWithArgs } from "../../../../../hooks/useAction";
import { GeometryEditorMode, geometryModeSet } from "../../../../../ducks/geometryEditor/geometryEditor";
import { GeometryModeControlProps } from "../types";

type ToggleGeometryModeButtonProps = GeometryModeControlProps & {
  className?: string;
  mode: GeometryEditorMode;
  selectMode: GeometryEditorMode;
};

export const ToggleGeometryModeButton: FC<ToggleGeometryModeButtonProps> = ({ kind, title, mode, selectMode }) => {
  const setGeometryTransformMode = useActionWithArgs(geometryModeSet, selectMode);

  return (
    <IconToggle kind={kind} title={title} isSelected={mode === selectMode} onClick={setGeometryTransformMode} accent />
  );
};
